import React from 'react';
import { useSearchParams } from 'react-router-dom';

const GMDNotificationPreview = () => {
  const [searchParams] = useSearchParams();
  
  // Get params from URL or use defaults
  const type = searchParams.get('type') || 'transaction';
  const amount = searchParams.get('amount') || '500000';
  const description = searchParams.get('description') || 'Office Equipment Purchase';
  const transactionNumber = searchParams.get('number') || 'TRANS-2026-001';
  
  return (
    <div style={{
      margin: 0,
      padding: '40px 20px',
      fontFamily: "'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif",
      background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
      minHeight: '100vh'
    }}>
      
      <div style={{
        maxWidth: '650px',
        margin: '0 auto',
        background: '#ffffff',
        borderRadius: '16px',
        overflow: 'hidden',
        boxShadow: '0 20px 60px rgba(0, 0, 0, 0.3)'
      }}>
        
        {/* Header */}
        <div style={{
          background: 'linear-gradient(135deg, #1e40af 0%, #3b82f6 100%)',
          padding: '40px 32px',
          textAlign: 'center',
          position: 'relative'
        }}>
          
          <div style={{
            background: 'white',
            width: '120px',
            height: '120px',
            borderRadius: '50%',
            margin: '0 auto 20px',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            boxShadow: '0 8px 20px rgba(0, 0, 0, 0.15)'
          }}>
            <img 
              src="/logo.png" 
              alt="Puffin Group" 
              style={{
                width: '90px',
                height: '90px',
                objectFit: 'contain'
              }}
              onError={(e) => {
                e.target.style.display = 'none';
                e.target.nextSibling.style.display = 'block';
              }}
            />
            <div style={{
              display: 'none',
              color: '#1e40af',
              fontSize: '40px',
              fontWeight: '700'
            }}>
              PG
            </div>
          </div>
          
          <h1 style={{
            color: 'white',
            margin: '0 0 8px',
            fontSize: '28px',
            fontWeight: '700',
            letterSpacing: '-0.5px'
          }}>
            PUFFIN GROUP LTD
          </h1>
          
          <p style={{
            color: 'rgba(255, 255, 255, 0.9)',
            margin: 0,
            fontSize: '14px',
            fontWeight: '500'
          }}>
            Enterprise Resource Planning System
          </p>
        </div>

        {/* Alert Badge */}
        <div style={{
          background: '#fef3c7',
          borderLeft: '4px solid #f59e0b',
          padding: '16px 24px',
          display: 'flex',
          alignItems: 'center',
          gap: '12px'
        }}>
          <div style={{
            background: '#f59e0b',
            color: 'white',
            width: '32px',
            height: '32px',
            borderRadius: '50%',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            fontSize: '18px',
            fontWeight: 'bold',
            flexShrink: 0
          }}>
            !
          </div>
          <div>
            <div style={{
              color: '#92400e',
              fontSize: '14px',
              fontWeight: '700',
              marginBottom: '2px'
            }}>
              ACTION REQUIRED
            </div>
            <div style={{
              color: '#78350f',
              fontSize: '13px'
            }}>
              New {type === 'transaction' ? 'Finance Transaction' : 'Purchase Request'} Awaiting Your Approval
            </div>
          </div>
        </div>

        {/* Main Content */}
        <div style={{ padding: '32px' }}>
          
          <p style={{
            color: '#374151',
            fontSize: '16px',
            lineHeight: '1.6',
            margin: '0 0 24px'
          }}>
            Dear <strong>Group Managing Director</strong>,
          </p>

          <p style={{
            color: '#4b5563',
            fontSize: '15px',
            lineHeight: '1.6',
            margin: '0 0 28px'
          }}>
            A new {type === 'transaction' ? 'finance transaction' : 'purchase request'} has been submitted and requires your approval. Please review the details below:
          </p>

          {/* Transaction Details Card */}
          <div style={{
            background: 'linear-gradient(135deg, #f0f9ff 0%, #e0f2fe 100%)',
            border: '2px solid #bae6fd',
            borderRadius: '12px',
            padding: '24px',
            marginBottom: '28px'
          }}>
            
            <div style={{
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center',
              marginBottom: '20px',
              paddingBottom: '16px',
              borderBottom: '2px solid #bae6fd'
            }}>
              <div>
                <div style={{
                  color: '#0369a1',
                  fontSize: '12px',
                  fontWeight: '600',
                  textTransform: 'uppercase',
                  letterSpacing: '0.5px',
                  marginBottom: '4px'
                }}>
                  Transaction Number
                </div>
                <div style={{
                  color: '#0c4a6e',
                  fontSize: '18px',
                  fontWeight: '700',
                  fontFamily: 'monospace'
                }}>
                  {transactionNumber}
                </div>
              </div>
              <div style={{
                background: '#dc2626',
                color: 'white',
                padding: '8px 16px',
                borderRadius: '20px',
                fontSize: '12px',
                fontWeight: '700',
                textTransform: 'uppercase',
                letterSpacing: '0.5px'
              }}>
                URGENT
              </div>
            </div>

            <div style={{ marginBottom: '16px' }}>
              <div style={{
                color: '#0369a1',
                fontSize: '12px',
                fontWeight: '600',
                textTransform: 'uppercase',
                marginBottom: '6px'
              }}>
                Description
              </div>
              <div style={{
                color: '#0c4a6e',
                fontSize: '15px',
                fontWeight: '500',
                lineHeight: '1.5'
              }}>
                {description}
              </div>
            </div>

            <div style={{ marginBottom: '16px' }}>
              <div style={{
                color: '#0369a1',
                fontSize: '12px',
                fontWeight: '600',
                textTransform: 'uppercase',
                marginBottom: '6px'
              }}>
                Submitted By
              </div>
              <div style={{
                color: '#0c4a6e',
                fontSize: '15px',
                fontWeight: '500'
              }}>
                Finance Department
              </div>
            </div>

            <div style={{
              background: 'linear-gradient(135deg, #059669 0%, #10b981 100%)',
              borderRadius: '10px',
              padding: '20px',
              marginTop: '20px',
              textAlign: 'center'
            }}>
              <div style={{
                color: 'rgba(255, 255, 255, 0.9)',
                fontSize: '13px',
                fontWeight: '600',
                marginBottom: '6px',
                textTransform: 'uppercase',
                letterSpacing: '0.5px'
              }}>
                Total Amount
              </div>
              <div style={{
                color: 'white',
                fontSize: '32px',
                fontWeight: '700',
                letterSpacing: '-0.5px'
              }}>
                ₦{parseFloat(amount).toLocaleString('en-NG', { minimumFractionDigits: 2 })}
              </div>
            </div>
          </div>

          {/* Action Button */}
          <div style={{ textAlign: 'center', marginBottom: '28px' }}>
            <a 
              href={`${window.location.origin}/gmd/dashboard`}
              style={{
                display: 'inline-block',
                background: 'linear-gradient(135deg, #1e40af 0%, #3b82f6 100%)',
                color: 'white',
                padding: '16px 48px',
                borderRadius: '10px',
                textDecoration: 'none',
                fontSize: '16px',
                fontWeight: '700',
                boxShadow: '0 10px 25px rgba(59, 130, 246, 0.4)',
                transition: 'all 0.3s ease'
              }}
            >
              Review & Approve Now →
            </a>
          </div>

          <div style={{
            background: '#f3f4f6',
            borderRadius: '8px',
            padding: '16px',
            marginBottom: '24px'
          }}>
            <div style={{
              color: '#6b7280',
              fontSize: '13px',
              lineHeight: '1.6'
            }}>
              <strong style={{ color: '#374151' }}>⏰ Time Sensitive:</strong> This transaction requires your immediate attention. Please log in to the ERP system to review and approve.
            </div>
          </div>

          <p style={{
            color: '#6b7280',
            fontSize: '14px',
            lineHeight: '1.6',
            margin: '0 0 8px'
          }}>
            Best regards,<br />
            <strong style={{ color: '#374151' }}>Puffin Group ERP System</strong>
          </p>
        </div>

        {/* Footer */}
        <div style={{
          background: '#f9fafb',
          padding: '24px 32px',
          borderTop: '1px solid #e5e7eb'
        }}>
          <div style={{
            color: '#9ca3af',
            fontSize: '12px',
            textAlign: 'center',
            lineHeight: '1.6'
          }}>
            <p style={{ margin: '0 0 8px' }}>
              <strong style={{ color: '#6b7280' }}>Puffin Group Ltd</strong>
            </p>
            <p style={{ margin: '0 0 8px' }}>
              Enterprise Resource Planning System
            </p>
            <p style={{ margin: '0 0 12px' }}>
              This is an automated notification. Please do not reply to this email.
            </p>
            <div style={{
              paddingTop: '12px',
              borderTop: '1px solid #e5e7eb'
            }}>
              <p style={{ margin: 0 }}>
                © {new Date().getFullYear()} Puffin Group Ltd. All rights reserved.
              </p>
            </div>
          </div>
        </div>
      </div>

      {/* Preview Info */}
      <div style={{
        maxWidth: '650px',
        margin: '20px auto 0',
        padding: '16px',
        background: 'rgba(255, 255, 255, 0.95)',
        borderRadius: '8px',
        textAlign: 'center'
      }}>
        <p style={{
          color: '#374151',
          fontSize: '13px',
          margin: 0
        }}>
          📧 <strong>Email Preview</strong> - This is how GMD notification emails will appear
        </p>
      </div>
    </div>
  );
};

export default GMDNotificationPreview;
